import { useApi } from "utils";
import { ApproveType, FillType } from "../../types";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";

export function useApprovalList({ page, approval_status, limit, sort,start_date,end_date }: FillType) {

  console.log(start_date);
  
  const defaultValue = {
    payload: {
      listfile: [],
      pagination_data: {
        page: 0,
        pages: 0,
        size: 0,
        total: 0
      }
    },
  }

  const api = useApi();
  const [data, setData] = useState<DataTypePaging>(defaultValue);
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (page) params.page = page;
  if (approval_status) params.approve_status = approval_status;
  if (limit) params.limit = limit;
  if (sort) params.sort = sort;
  if (start_date) params.date_from = start_date;
  if (end_date) params.date_end = end_date;

  const fetchUrl = () => api.get("/list_build_item/builditems?",{params})

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<DataTypePaging>) => setData(res.data))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    }
    // eslint-disable-next-line
  }, [page, approval_status, limit, sort, start_date, end_date]);

  return { data, isLoading, refetch }
}

type DataTypePaging = {
  payload: {
    listfile: ApproveType[];
    pagination_data: {
      total: number;
      page: number;
      size: number;
      pages: number;
    }
  }
}